export default __webpack_public_path__ + "static/Witcher-ea2e3f501b0c77cccf74532c779c088b.png";